import {
    Card, CardBody, ListGroup, Table,
} from 'reactstrap';
import moment from 'moment';
import { MomentDateFormat } from '@s20/common/constants/momentFormats';
import HistoryAccordion from './HistoryAccordion';
import PropertyChange, {
    PropertyChangeListItem,
    propertyShouldNotBeDisplayed,
} from './PropertyChange';

const getModifiedByIdentity = (historicalChangeSet) => {
    const {
        modifiedByFirstName,
        modifiedByLastName,
        modifiedByUserName,
    } = historicalChangeSet;
    const hasName = Boolean(modifiedByFirstName || modifiedByLastName);
    const displayName = modifiedByFirstName && modifiedByLastName
        ? `${modifiedByLastName}, ${modifiedByFirstName}`
        : modifiedByFirstName || modifiedByLastName || modifiedByUserName || 'System Import';

    return {
        displayName,
        userName: hasName ? modifiedByUserName : null,
    };
};

const getRelevantPropertyChanges = (
    historicalChangeSet,
    propertiesToIgnore,
) => {
    if (!propertiesToIgnore || !propertiesToIgnore.length) {
        return historicalChangeSet.propertyChanges;
    }

    return historicalChangeSet.propertyChanges.filter(
        (pc) => !propertiesToIgnore.includes(pc.property),
    );
};

const HistoricalChangeSet = (props) => {
    const {
        historicalChangeSet, propertiesToIgnore, renderOptions,
    } = props;

    if (
        !historicalChangeSet
        || !historicalChangeSet.propertyChanges
        || historicalChangeSet.propertyChanges.length === 0
    ) {
        return null;
    }

    // A default (year-1) stamp means the change predates versioning — a system-created baseline row
    // with no recorded date — so the entry shows without one.
    const changeDate = moment.utc(historicalChangeSet.changeDate);
    const changeDateLabel = changeDate.year() > 1
        ? changeDate.local().format(MomentDateFormat.DateTimeLongAnte)
        : '';

    const { displayName, userName } = getModifiedByIdentity(historicalChangeSet);

    const relevantPropertyChanges = getRelevantPropertyChanges(
        historicalChangeSet,
        propertiesToIgnore,
    ).filter((pc) => !propertyShouldNotBeDisplayed(pc));

    if (relevantPropertyChanges.length === 0) {
        return null;
    }

    return (
        <HistoryAccordion
            changeCount={relevantPropertyChanges.length}
            title={changeDateLabel}
            userDisplayName={displayName}
            userName={userName}
        >
            <CardBody className="bg-body-secondary">
                <Card className="d-none d-sm-block overflow-hidden">
                    <Table
                        hover
                        size="sm"
                        className="mb-0 small align-middle"
                        aria-label="Changes in this version"
                    >
                        <thead className="table-light">
                            <tr>
                                <th scope="col">Field</th>
                                <th scope="col">Before</th>
                                <th scope="col">After</th>
                            </tr>
                        </thead>
                        <tbody>
                            {relevantPropertyChanges.map((pc) => (
                                <PropertyChange
                                    propertyChange={pc}
                                    key={pc.property}
                                    renderOptions={renderOptions}
                                />
                            ))}
                        </tbody>
                    </Table>
                </Card>

                <ListGroup className="d-sm-none small">
                    {relevantPropertyChanges.map((pc) => (
                        <PropertyChangeListItem
                            propertyChange={pc}
                            key={pc.property}
                            renderOptions={renderOptions}
                        />
                    ))}
                </ListGroup>
            </CardBody>
        </HistoryAccordion>
    );
};

export default HistoricalChangeSet;
